import {
  NoShowLateHandlingBookingListQuery,
  NoShowLateHandlingBookingListQueryVariables,
} from "@/gql/graphql";
import { gql, useLazyQuery } from "@apollo/client";

export const handleBookingsFragment = gql`
  fragment HandleBookingData on HandleBookingBookingData {
    id
    codeNoShowLateType {
      id
      code
      description
    }
    consignmentNo
    handlingStatus
    consignment {
      id
      sailingArchive {
        departureDate
        departureTime
        route {
          code
        }
      }
    }
    month
    bookingNo
    bookingVersion
    route {
      id
      code
      routePair {
        id
        code
      }
    }
    departureDate
    departureTime
    vehicleType {
      id
      code
      shortDescription
    }
    vehicleReg
    trailerReg
    customerReference
    revisedDate
    revisedTime
    excludeReason {
      id
      code
      description
    }
    loadingListMessage
    note
    lateHandlingDate
    lateHandlingUser
    dateModified
    modifiedBy
  }
`;

export const noShowLateHandlingBookingDataQuery = gql`
  ${handleBookingsFragment}
  fragment NslhBookingData on NoShowLateHandlingHandleBookingsData {
    id
    customer {
      id
      custIndex
      custNo
      name
      modeOfPay
    }
    region
    seller
    noOfToDo
    noOfToBeInvoiced
    noOfInvoiced
    noOfDoNotInvoice
    noOfThreshold
    noOfNotChargeable
    customerBookings {
      ...HandleBookingData
    }
  }
  query NoShowLateHandlingBookingList(
    $filterOptions: NoShowLateHandlingBookingsByFilterOptions!
  ) {
    productPrice {
      noShowLateHandlingBookings {
        byFilter(filterOptions: $filterOptions) {
          bookingsData {
            ...NslhBookingData
          }
        }
      }
    }
  }
`;

export const useNoShowLateHandlingBookingListQuery = () => {
  const [fetchNoShowLateHandlingBookings, { loading, data, error }] =
    useLazyQuery<
      NoShowLateHandlingBookingListQuery,
      NoShowLateHandlingBookingListQueryVariables
    >(noShowLateHandlingBookingDataQuery, {
      fetchPolicy: "network-only",
      nextFetchPolicy: "cache-first",
      notifyOnNetworkStatusChange: true,
    });

  return {
    error,
    loading,
    noShowLateHandlingBookingData:
      data?.productPrice.noShowLateHandlingBookings?.byFilter.bookingsData,
    fetchNoShowLateHandlingBookings,
  };
};
